import React from "react";

const IconPayrollProcessing = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none" className={className}>
    <path
      d="M12 20.51C15.31 20.51 18 17.82 18 14.51C18 11.2 15.31 8.51001 12 8.51001C8.69 8.51001 6 11.2 6 14.51C6 17.82 8.69 20.51 12 20.51Z"
      fill="url(#paint0_linear_146_320)"
    />
    <path
      d="M1 10.43V18.57C1 19.77 0.99999 20.37 1.23999 20.83C1.44999 21.23 1.79 21.56 2.2 21.77C2.67 22 3.29 22 4.52 22H19.48C20.71 22 21.33 22 21.8 21.77C22.21 21.57 22.55 21.24 22.76 20.83C23 20.37 23 19.77 23 18.57V10.43C23 9.22999 23 8.62998 22.76 8.16998C22.55 7.76998 22.21 7.43998 21.8 7.22998C21.33 6.99998 20.71 7 19.48 7H4.52C3.29 7 2.67 6.99998 2.2 7.22998C1.79 7.42998 1.44999 7.75998 1.23999 8.16998C0.99999 8.62998 1 9.22999 1 10.43Z"
      stroke="#191E49"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 4H21" stroke="#191E49" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 1H19" stroke="#191E49" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 10.01V11.05" stroke="#191E49" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9.87988 16.91C10.7199 17.69 11.8999 17.83 12.6099 17.67C13.3199 17.51 14.1299 16.9299 14.1299 16.0699C14.1299 15.2099 13.4199 14.52 12.5399 14.52H11.4799C10.5999 14.52 9.88988 13.81 9.88988 12.96C9.88988 12.11 10.6899 11.52 11.4099 11.36C12.1299 11.2 13.3099 11.34 14.1399 12.12M11.9999 19.0099V17.97"
      stroke="#191E49"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="paint0_linear_146_320" x1="12" y1="8.51001" x2="12" y2="20.51" gradientUnits="userSpaceOnUse">
        <stop stopColor="#C098F5" />
        <stop offset="1" stopColor="#C098F5" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconPayrollProcessing;
